﻿import { Directive, Input, Output, EventEmitter, ElementRef, HostListener, OnInit, AfterViewInit, Renderer, OnDestroy } from '@angular/core';

@Directive({
    selector: '[viewport-visible]'
})
export class ViewportVisibleDirective {

    @Output('viewport-visible') onViewportVisible = new EventEmitter<boolean>();
    intervalHandle: number | null = null;

    constructor(private eleRef: ElementRef) {}

    ngAfterViewInit() {
        this.intervalHandle = window.setInterval(() => {
            if (this.elementIsVisible(this.eleRef.nativeElement)) {
                this.onViewportVisible.emit(true);
            }
        }, 300);
    }

    ngOnDestroy() {
        if (this.intervalHandle) {
            window.clearInterval(this.intervalHandle);
            this.intervalHandle = null;
        }
    }

    private elementIsVisible(elm: HTMLElement, threshold: number = 0, mode: 'above' | 'below' | 'visible' = 'visible'): boolean {
        var rect = elm.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        var above = rect.bottom - threshold < 0;
        var below = rect.top - viewHeight + threshold >= 0;

        return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
    }


}